module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan2501-sp-c92bf862df76ced0bf27d6649c296b9b.png";